import React, { useCallback } from 'react';
import {
  Route,
  Routes,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import { HStack, Image, Pressable } from 'native-base';
import { UserDashboardPage } from './UserDashboardPage';
import { DashboardPageStateProvider } from '../../hooks/useDashboardPageState';
import { PhaseDrawer } from './PhaseDrawer';

const backBttn = '../chevron-left-white.png';

export const UserDetails = () => {
  const { patient } = useParams();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const handlePhaseLink = useCallback(
    (phase) => {
      navigate(`/user-details/${patient}/${phase}`);
    },
    [navigate, patient]
  );

  return (
    <DashboardPageStateProvider patientId={patient}>
      <Routes>
        <Route
          path={'/'}
          element={
            <UserDashboardPage
              header={
                <HStack
                  px={8}
                  backgroundColor={'secondary.500'}
                  height={'64px'}
                  position={'relative'}
                >
                  <Pressable
                    variant={'closer'}
                    onPress={() => {
                      navigate(`/hc-dashboard?${searchParams}`);
                    }}
                    position={'absolute'}
                  >
                    <Image
                      alt="back button"
                      height={'32px'}
                      source={backBttn}
                      width={'32px'}
                      zIndex="1"
                      top={'16px'}
                    />
                  </Pressable>
                </HStack>
              }
              onPhaseDetailsClick={handlePhaseLink}
              onPhaseLinkClick={handlePhaseLink}
            />
          }
        >
          <Route
            path={':phase'}
            element={
              <PhaseDrawer
                onClose={() => navigate(`/user-details/${patient}`)}
              />
            }
          ></Route>
        </Route>
      </Routes>
    </DashboardPageStateProvider>
  );
};
